import React, { useState } from "react";
import {
  Paper,
  Box,
} from "@mui/material";
import axios from "axios";
import CandidatesInfiniteScroll from "./CandidatesInfiniteScroll";
import DynamicFormsInfiniteScroll from "./DynamicFormsInfiniteScroll";
import BlacklistInfiniteScroll from "./BlacklistInfiniteScroll";
const apiUrl = process.env.REACT_APP_API_URL;

const CombinedTablesView = ({
  enableInfiniteScroll = true, // Enable infinite scroll by default
  infiniteScrollPageSize = 2, // Page size for infinite scroll - 2 by 2
} = {}) => {
  const [tableType, setTableType] = useState("candidates");
  const [viewType, setViewType] = useState("card");


  // Helper function to parse JWT token
  const parseJwt = (token) => {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  };

  // Helper function to get user ID from access token
  const getUserIdFromAccessToken = () => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      console.error("No access token found in local storage");
      return null;
    }

    try {
      const decodedToken = parseJwt(accessToken);
      return decodedToken.user_id;
    } catch (error) {
      console.error("Failed to decode access token", error);
      return null;
    }
  };






  const handleViewTypeChange = () => {
    setViewType(viewType === "card" ? "list" : "card");
  };




  // Handle unblock function for blacklist
  const handleUnblock = async (candidateId) => {
    try {
      const recruiterId = getUserIdFromAccessToken();
      const response = await axios.delete(
        `${apiUrl}authentication/blacklist/create/`,
        {
          data: { recruiter_id: recruiterId, candidate_id: candidateId },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );

      if (response.status === 204 || (response.data && response.data.status === "success")) {
        // Data will be refreshed automatically by the infinite scroll components
        console.log("Candidate unblocked successfully");
      }
    } catch (error) {
      console.error("Error unblocking candidate:", error);
    }
  };


  const renderTable = () => {
    switch (tableType) {
      case "candidates":
        return (
          <CandidatesInfiniteScroll
            viewType={viewType}
            setViewType={handleViewTypeChange}
            onNavigateToBlacklist={() => setTableType("blacklist")}
            onNavigateToDynamicForms={() => setTableType("dynamicForms")}
            infiniteScrollPageSize={infiniteScrollPageSize}
          />
        );
      case "dynamicForms":
        return (
          <DynamicFormsInfiniteScroll
            viewType={viewType}
            setViewType={handleViewTypeChange}
            onNavigateToApplicationTable={() => setTableType("candidates")}
            onNavigateToBlacklist={() => setTableType("blacklist")}
            infiniteScrollPageSize={infiniteScrollPageSize}
          />
        );
      case "blacklist":
        return (
          <BlacklistInfiniteScroll
            viewType={viewType}
            setViewType={handleViewTypeChange}
            onNavigateToApplicationTable={() => setTableType("candidates")}
            onNavigateToDynamicForms={() => setTableType("dynamicForms")}
            onUnblock={handleUnblock}
            infiniteScrollPageSize={infiniteScrollPageSize}
          />
        );
      default:
        return (
          <CandidatesInfiniteScroll
            viewType={viewType}
            setViewType={handleViewTypeChange}
            onNavigateToBlacklist={() => setTableType("blacklist")}
            onNavigateToDynamicForms={() => setTableType("dynamicForms")}
            infiniteScrollPageSize={infiniteScrollPageSize}
          />
        );
    }
  };

  return (
    <Paper
      sx={{
        p: { xs: 1, sm: 2 },
        overflow: "hidden",
      }}
    >

      <Box sx={{}}>{renderTable()}</Box>
    </Paper>
  );
};

export default CombinedTablesView;
